module.exports = __webpack_public_path__ + "img/christmas-highlight-2.715e1ae6.jpg";